<div class="doc-page">
    <div class="doc-shell">
        <header class="doc-header">
            <p class="doc-eyebrow">Informativa</p>
            <h1 class="doc-title">Informativa sulla privacy</h1>
            <p class="doc-lead">
                Come trattiamo i tuoi dati personali quando usi il servizio.
            </p>
        </header>

        <div class="doc-card">
            <object
                data="assets/doc/Informativa_sulla_privacy.pdf#view=FitH"
                type="application/pdf"
                width="100%"
                height="100%">
                <div class="doc-fallback">
                    <p>Il tuo browser non supporta i PDFs.</p>
                    <a href="/assets/doc/Informativa_sulla_privacy.pdf" class="fo-btn fo-btn--primary">Download the PDF</a>
                </div>
            </object>
        </div>
    </div>
</div>
